var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0329 3.70617C20.0329 3.70617 21.9021 2.97726 21.7457 4.74734C21.6942 5.47626 21.2271 8.0277 20.8633 10.787L19.6172 18.9614C19.6172 18.9614 19.5133 20.159 18.5784 20.3673C17.6441 20.5751 16.2421 19.6384 15.9822 19.4301C15.7744 19.2737 12.088 16.9306 10.7899 15.7855C10.4261 15.4727 10.0104 14.8482 10.8418 14.1193L16.2935 8.9125C16.9166 8.28799 17.5397 6.83016 14.9435 8.60025L7.67358 13.5463C7.67358 13.5463 6.84266 14.0674 5.28524 13.5987L1.90961 12.5571C1.90961 12.5571 0.663482 11.7762 2.79249 10.9953C7.98535 8.54829 14.3724 6.04929 20.0319 3.70617H20.0329Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/telegram.0f9508fb739b35c48cab72306f0b8fa5.svg";
export { ForwardRef as ReactComponent };